import { TicketSeason } from '../../../../domain/tickets';

export const DAY_BG_COLOR: Record<TicketSeason, string> = {
  [TicketSeason.High]: '#EF60A3',
  [TicketSeason.Low]: '#D9D9D9',
  [TicketSeason.Regular]: '#3F2B56',
};

export const DAY_TEXT_COLOR: Record<TicketSeason, string> = {
  [TicketSeason.High]: '#FFFFFF',
  [TicketSeason.Low]: '#000000',
  [TicketSeason.Regular]: '#FFFFFF',
};

const DAY_OF_WEEKS_EN = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const DAY_OF_WEEKS_ES = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

export const getDaysOfWeekByLocale = (locale: string) => (locale === 'es' ? DAY_OF_WEEKS_ES : DAY_OF_WEEKS_EN);

const MONTHS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const MONTHS_ES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const getMonthsByLocale = (locale: string) => (locale === 'es' ? MONTHS_ES : MONTHS_EN);

export const getDaysOfMonth = (year: number, month: number) => {
  // Determine the first day of the month
  const firstDayOfMonth = new Date(year, month, 1);
  const firstDayOfWeek = firstDayOfMonth.getDay(); // 0 for Sunday, 1 for Monday, etc.

  // Determine the last day of the month
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const numberOfDaysInMonth = lastDayOfMonth.getDate();

  // Initialize an array to store the days of the month
  const daysOfMonth: TicketsSeasonsCalendarDay[] = [];

  // Loop through the days of the month
  for (let i = 1; i <= numberOfDaysInMonth; i++) {
    daysOfMonth.push({
      day: i,
      dayOfWeek: (firstDayOfWeek + i - 1) % 7, // Normalize dayOfWeek to range from 0 to 6
    });
  }

  const firstEmptyDays = Array.from({ length: daysOfMonth[0].dayOfWeek ?? 0 }).fill({
    day: null,
    dayOfWeek: null,
  }) as TicketsSeasonsCalendarDay[];
  const lastEmptyDays = Array.from({ length: 6 - (daysOfMonth.at(-1)?.dayOfWeek ?? 0) }).fill({
    day: null,
    dayOfWeek: null,
  }) as TicketsSeasonsCalendarDay[];

  return [...firstEmptyDays, ...daysOfMonth, ...lastEmptyDays];
};

export interface TicketsSeasonsCalendarDay {
  day: number | null;
  dayOfWeek: number | null;
}
